import React from 'react';
import { Formik, Form } from 'formik';
import Loader from 'features/Loader/Loader';
import Title from 'shared/components/title/Title';
import TextAreaField from 'shared/components/text-area-field/TextAreaField';
import { notesSchema } from 'utils/validators/notes';
import NoteHead from './NoteHead';

class NoteForm extends React.Component {
  render() {
    let { titleParams, history } = this.props;
    return (
      <Formik
        enableReinitialize={true}
        initialValues={{
          text: this.props.initialTextValues
        }}
        onSubmit={values => {
          return this.props.submitForm(values.text);
        }}
        validationSchema={notesSchema}
      >
        {formik => (
          <Form>
            {formik.isSubmitting ? (
              <Loader />
            ) : (
              <div className="client-form-pages">
                <div className="container">
                  <NoteHead text="Note" clientId={this.props.clientId} history={history} />
                  <Title
                    pageTitle={titleParams.pageTitle}
                    linkText={titleParams.linkText}
                    buttonText={titleParams.buttonText}
                    cancelLink={titleParams.cancelLink}
                    backBtn={titleParams.backBtn}
                    history={titleParams.history}
                    params={titleParams.params}
                  />

                  <div className="add-note-page">
                    <TextAreaField
                      name="text"
                      placeholder="Add Note"
                      maxLength={500}
                      autofocus={true}
                    />
                  </div>
                </div>
              </div>
            )}
          </Form>
        )}
      </Formik>
    );
  }
}

export default NoteForm;
